<!-- prettier-ignore -->

<div #timelineRef class="timeline-container" [ngClass]="{'no-touch': disableTouch()}" cdkScrollable>

    <div class="hours-dividers-container">
        @for (hour of totalAvailableHours; track $index) {
            <hr class="hours-divider">
        }
    </div>

    <div cdkDropListGroup class="cards-container">

        <div class="hours-container" autoScrollDisabled="false">
            @for (hour of totalAvailableHours; track $index;) {
                <div class="hour-wrapper">
                    <span class="hourStyle"> {{hour}} </span>
                </div>
            }
        </div>

        @for (day of route(); track day; let dayIndex = $index) {
            <div 
                #dropList cdkDropList class="card-item-wrapper" autoScrollDisabled="true" (cdkDropListDropped)="drop($event, dayIndex)" 
                [cdkDropListData]="day.points" [attr.index]="dayIndex" [cdkDropListEnterPredicate]="allowEnter"
            >
                <div class="days-button" [ngStyle]="{'background': PRIMARY_TIMELINE_COLORS[dayIndex]}">
                    {{'Día' | translate}} {{ dayIndex + 1 }}
                </div>
                <span class="days-span">
                    {{ day.date | date:'EEE' : '+0200' : tools.getCurrentLangDates() }} 
                    {{day.date | date: 'd' : '+0200' : tools.getCurrentLangDates()}}, 
                    {{day.date | date: 'MMMM' : '+0200' : tools.getCurrentLangDates()}}
                </span>
                @for (point of day.points; track point; let pointIndex = $index) {
                    @if(point?.type === 'point' || point?.type === 'event'){
                        <div 
                            class="card-item" #cardDragRef="cdkDrag" cdkDrag  (cdkDragMoved)="onDragMove($event, point)"  (cdkDragDropped)="onCardDrop($event, point, dayIndex)" (pointerdown)="onPointerDown($event)" (pointerup)="onPointerUp($event)"
                            [cdkDragData]="point" [attr.index]="pointIndex" (cdkDragReleased)="onDragReleased($event, point)" [cdkDragStartDelay]="delay()" (cdkDragStarted)="onDragStarted()" (cdkDragEnded)="onDragEnded()"
                        >
                            <ng-template cdkDragPlaceholder>
                                <timeline-card [item]="point"></timeline-card>
                            </ng-template>
                            <timeline-card [item]="point"></timeline-card>
                        </div>
                    }
                    @else {
                        <div (click)="addItem(dayIndex, pointIndex)" class="card-item" #cardDragRef="cdkDrag" cdkDrag [cdkDragData]="point" [cdkDragStartDelay]="delay()" [attr.index]="pointIndex" cdkDragLockAxis="y"  (cdkDragStarted)="onDragStarted()" (cdkDragEnded)="onDragEnded()"  (pointerdown)="onPointerDown($event)" (pointerup)="onPointerUp($event)">
                            <ng-template cdkDragPlaceholder>
                                <timeline-card [item]="point" [color]="PRIMARY_TIMELINE_COLORS[dayIndex]"></timeline-card>
                            </ng-template>
                            <timeline-card [item]="point" [color]="PRIMARY_TIMELINE_COLORS[dayIndex]"></timeline-card>
                        </div>
                    }
                } 
            </div>
        }            
    </div>

  </div>
